import React from '../services/React';
import { debounce } from '../services/utils';
import './InlineMenu.css';

class InlineMenu extends React.Component {
  constructor(props) {
    super(props);

    this.toggleOpen = this.toggleOpen.bind(this);
    this.setContainer = this.setContainer.bind(this);
    this.handle = this.handle.bind(this);
    this.openMenu = this.openMenu.bind(this);
    // close menu after 500ms (if this.openMenu() wasn't
    // called in that time)
    this.debouncedCloseMenu = debounce(this.debouncedCloseMenu.bind(this), 150);

    this.state = {
      isOpen: false
    };
  }

  componentDidMount() {
    document.addEventListener('click', this.handle, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handle, true);
    this.debouncedCloseMenu.abort();
  }

  handle(ev) {
    if (this.container.contains && !this.container.contains(ev.target)) {
      this.toggleOpen(false);
    }
  }

  setContainer(ref) {
    this.container = ref;
  }

  toggleOpen(open = null) {
    this.setState(({ isOpen }) => ({
      isOpen: open !== null ? open : !isOpen
    }));
  }

  openMenu() {
    this.debouncedCloseMenu.abort();
    this.toggleOpen(true);
  }

  debouncedCloseMenu() {
    this.toggleOpen(false);
  }

  render() {
    const { items } = this.props;
    const { isOpen } = this.state;
    let menuHTML;

    if (isOpen) {
      const itemsHTML = items.map(({ label, iconSRC, ...otherProps }) => {
        let iconHTML;

        if (iconSRC) {
          iconHTML = (
            <img className="InlineMenu__MenuItemIcon" alt="" src={iconSRC} />
          );
        }

        return (
          <li className="InlineMenu__MenuItem" {...otherProps}>
            {iconHTML}{label}
          </li>
        );
      });

      menuHTML = (
        <div
          className="InlineMenu__Menu"
          onMouseEnter={this.openMenu}
          onMouseLeave={this.debouncedCloseMenu}
          onClick={ev => {
            ev.stopPropagation();
          }}
        >
          <ul>
            {itemsHTML}
          </ul>
        </div>
      );
    }

    return (
      <div className="InlineMenu" ref={this.setContainer}>
        <div
          className="InlineMenu__TriggerButton"
          onMouseEnter={this.openMenu}
          onMouseLeave={this.debouncedCloseMenu}
          onClick={ev => {
            ev.stopPropagation();
          }}
        >
          …
        </div>
        {menuHTML}
      </div>
    );
  }
}

export default InlineMenu;



// WEBPACK FOOTER //
// ./src/commons/components/InlineMenu.jsx